import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { useAuth } from "../../components/context/authContext";
import { apiFetchCurrentUserDetails } from "../../api/backend/user";
import { apiGetOfferSchedules } from "../../api/backend/brandAmbassador";
import { SmallPlainInsetBtn, ImgTopBtn } from "../../components/buttons";
import {
  MoneyBagIcon,
  EventCalendarIcon,
  EarnedIcon,
  LineIntersectingCircleIcon,
} from "../../components/icons";
import Loader from "../../components/loader/loader";
import "./fieldLeaderDashboard.scss";

const FieldLeaderDashboard = () => {
  const { userId } = useParams();
  const navigate = useNavigate();
  const { handleLogout } = useAuth();
  const [profileData, setProfileData] = useState(null);
  const [offerCount, setOfferCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    async function loadAll() {
      try {
        const userResp = await apiFetchCurrentUserDetails(userId);
        if (!active) return;
        setProfileData(userResp.data);
        const role = userResp.data.role;
        const offersResp = await apiGetOfferSchedules(userId, role);
        if (!active) return;
        const offers = Array.isArray(offersResp.data.schedules)
          ? offersResp.data.schedules
          : [];
        setOfferCount(offers.length);
      } catch (e) {
        console.error(e);
        if (active) setError(e);
      } finally {
        if (active) setLoading(false);
      }
    }
    loadAll();
    return () => {
      active = false;
    };
  }, [userId]);

  const scrollWithOffset = (el, offset = 50) => {
    const top = el.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top, behavior: "smooth" });
  };
  if (loading) return <Loader />;
  if (error) return <div>Error: {error.message}</div>;
  if (!profileData) return <div>No profile found.</div>;
  const onLogoutClick = () => {
    handleLogout();
    navigate("/");
  };

  const minimalUser = { id: profileData.id, role: profileData.role };
  return (
    <div id="leaderTop" className="field-leader-dashboard">
      <p>Field Leader Dashboard Panel</p>

      <div className="top-ambassadordash-section">
        <h3>Hi {profileData.username}!</h3>
        <ImgTopBtn
          image={<LineIntersectingCircleIcon width="25" height="25" />}
          imgTopBtnWidth="50%"
          imgTopBtnTextFontSize="1.3rem"
          imgTopBtnFontColor="#b03a2e"
          imgTopBtnText="Logout"
          onClick={() => {
            onLogoutClick();
          }}
        />
        {/* Offers */}
        <HashLink
          to={`/offers-schedule-lists/${minimalUser.id}/offers#offerTop`}
          scroll={(el) => scrollWithOffset(el, 50)}
          style={{ textDecoration: "none" }}
        >
          <div className="offerNotifications">
            {offerCount > 0 && (
              <span className="offers-badge">{offerCount}</span>
            )}
            <SmallPlainInsetBtn
              image={
                <MoneyBagIcon
                  height="15px"
                  width="15px"
                  fillColor="var(--color-bloodred)"
                />
              }
              text="Offers"
              width="70px"
            />
          </div>
        </HashLink>

        {/* Schedule */}
        <HashLink
          to={`/staff/${minimalUser.id}/schedule#scheduleTop`}
          scroll={(el) => scrollWithOffset(el, 50)}
          style={{ textDecoration: "none" }}
        >
          <SmallPlainInsetBtn
            image={
              <EventCalendarIcon
                height="20px"
                width="20px"
                fillColor="var(--color-bloodred)"
              />
            }
            text="Schedule"
            width="100px"
          />
        </HashLink>
        {/* Accounts Payable */}
        <HashLink
          to={`/accounts-receivables-dashboard/${minimalUser.id}/accounts-receivables#acctReceivablesTop`}
          state={{ role: minimalUser.role }}
          scroll={(el) => scrollWithOffset(el, 50)}
          style={{ textDecoration: "none" }}
        >
          <ImgTopBtn
            image={
              <EarnedIcon
                height="20px"
                width="20px"
                style={{ paddingRight: "5px" }}
              />
            }
            imgTopBtnText="Accounts Payable"
            imgTopBtnWidth="250px"
            imgTopBtnFontColor="var(--color-bloodred)"
          />
        </HashLink>
      </div>
    </div>
  );
};

export default FieldLeaderDashboard;

// {/* Team Leaderboard Sections Tracking Current Team Performance
// // we will neeed to know who is working so the team leader can encourage them
// */}
// <AmbassadorLeaderBoard />
